import React, { useState, useEffect, useCallback } from 'react';
import {Link} from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; // 가정: 인증 컨텍스트




// --- 브라우저/기기 감지 유틸리티 함수들 ---
const isKakaoTalk = (ua: string) => /kakaotalk/i.test(ua);
const isLine = (ua: string) => /line/i.test(ua);
const isInAppBrowser = (ua: string) => /inapp|naver|instagram|fb_iab|fban|fbios/i.test(ua);
const isWebView = (ua: string) => isKakaoTalk(ua) || isLine(ua) || isInAppBrowser(ua);
const isAppleDevice = (ua: string) => /iphone|ipad|ipod/i.test(ua);



const Footer: React.FC = () => {
    
    // 팝업/모달의 표시 여부를 관리하는 상태
    const [showInAppAlert, setShowInAppAlert] = useState(false);
    const [inAppUrl, setInAppUrl] = useState('');
    const [showAppleAlert, setShowAppleAlert] = useState(false);
    
    // --- 인앱 브라우저 감지 및 처리 ---
    useEffect(() => {
        if (sessionStorage.getItem('externalBrowserPopupDismissed')) return;

        const useragent = navigator.userAgent.toLowerCase();
        if (!isWebView(useragent)) return;

        const currentUrl = window.location.href;
        let openUrl = '';

        if (isKakaoTalk(useragent)) {
            openUrl = `kakaotalk://web/openExternal?url=${encodeURIComponent(currentUrl)}`;
        } else if (isLine(useragent)) {
            const joinChar = currentUrl.includes('?') ? '&' : '?';
            openUrl = currentUrl + joinChar + 'openExternalBrowser=1';
        } else if (isInAppBrowser(useragent)) {
            openUrl = isAppleDevice(useragent)
                ? `x-safari-${currentUrl}`
                : `intent://${currentUrl.replace(/https?:\/\//i, '')}#Intent;scheme=http;package=com.android.chrome;end`;
        }

        if (openUrl) {
            setInAppUrl(openUrl);
            setShowInAppAlert(true);
        }
    }, []);


    return (
        <>
        <footer className="bg-dark text-white py-5"> {/* Increased vertical padding */}
                <div className="container">
                    <div className="row justify-content-center"> {/* Centered content */}
                        {/* Column for Navigation Links */}
                        <div className="col-md-4 mb-4 mb-md-0">
                            <h5 className="fw-bold mb-3">바로가기</h5>
                            <ul className="list-unstyled">
                                <li className="mb-2"><Link to="/guide" className="text-white text-decoration-none small">게임 가이드</Link></li>
                                <li className="mb-2"><Link to="/player" className="text-white text-decoration-none small">선수 명단</Link></li>
                                <li className="mb-2"><Link to="/dashboard" className="text-white text-decoration-none small">리그 대시보드</Link></li>
                                <li className="mb-2"><Link to="/ranking" className="text-white text-decoration-none small">2025년 랭킹</Link></li>
                                <li className="mb-2"><Link to="/user-ranking" className="text-white text-decoration-none small">유저 랭킹</Link></li>
                                {/* 기타 필요한 링크들 추가 */}
                            </ul>
                        </div>

                        {/* Column for Policies & Legal */}
                        <div className="col-md-4 mb-4 mb-md-0">
                            <h5 className="fw-bold mb-3">정책 및 약관</h5>
                            <ul className="list-unstyled">
                                <li className="mb-2"><Link to="/privacy" className="text-white text-decoration-none small">개인정보처리방침</Link></li>
                                <li className="mb-2"><Link to="/terms" className="text-white text-decoration-none small">이용약관</Link></li>
                            </ul>
                        </div>

                        {/* Column for Company Info & Contact */}
                        <div className="col-md-4">
                            <h5 className="fw-bold mb-3">회사 정보</h5>
                            <ul className="list-unstyled small">
                                <li className="mb-2">대표: 강윤재</li>
                                <li className="mb-2">사업자 등록번호: 596-33-01508</li>
                                <li className="mb-2">통신판매사업신고번호: 제 2025-서울중구-1100</li>
                                <li className="mb-2">고객센터: <a href="https://pf.kakao.com/_VrRXn" target="_blank" rel="noopener noreferrer" className="text-white text-decoration-none">플레이볼 카카오톡 플러스친구</a></li>
                                <li className="mb-2">서울시 중구 퇴계로 45길 15(원창빌딩 3층 301호)</li>
                            </ul>
                        </div>
                    </div>

                    <div className="text-center mt-5">
                        <a href="https://www.instagram.com/playballfantasy" target="_blank" rel="noopener noreferrer" className="text-white me-4">
                            <i className="bi bi-instagram fs-3"></i>
                        </a>
                        <a href="https://cafe.naver.com/playballfantasy" target="_blank" rel="noopener noreferrer" className="text-white">
                            <i className="bi bi-chat-square-dots-fill fs-3"></i>
                        </a>
                    </div>

                    <hr className="bg-secondary my-4" /> {/* Divider */}

                    {/* Bottom section for Logo and Copyright */}
                    <div className="text-center">
                        <p className="small mb-0">&copy; {new Date().getFullYear()} 플레이볼. All Rights Reserved.</p>
                    </div>
                </div>
            </footer>
           
            {/* Apple 기기 홈 화면 추가 안내 팝업 */}
            {showAppleAlert && (
                <div className="bottom-alert">
                    <button type="button" className="btn-close btn-close-white alert-close" onClick={() => setShowAppleAlert(false)}></button>
                    <div className="alert-content">
                        <div className="alert-title">홈 화면에 추가하고 더 편리하게 이용하세요</div>
                        <div className="alert-description">
                            빠르게 실행하고 알림도 받아볼 수 있어요!<br />
                            화면 하단에서 공유 버튼을 누르고, '홈 화면에 추가'를 선택해주세요.
                        </div>
                        
                    </div>
                </div>
            )}

            
        </>
    );
};

export default Footer;
